const translations = {
	page_title: "Souscription {{productName}} de {{civility}} {{subscriberName}}",
	page_title_corporation: "Souscription {{productName}} de {{corporationName}}",
	title: "Informations de la souscription",
	subscription_type: "Type de souscription",
	contrepartie: "Contrepartie",
	contrepartie_sans: "Sans contrepartie",
	validation_date: "Date de validation",
	due_date: "Date de jouissance",
	payout_date: "Date de versement des premiers loyers",
	share_number: "Nombre de parts",
	amount_subscribed: "Montant souscrit",
	estimation_amount: "Valorisation estimée en pleine propriété",
	attestation: "Attestation de part",
	signed: "Souscription signée par le client",
	estimation_amount_info:
		"Valorisation estimée (valeur de retrait) en fonction du nombre de parts possédé par le client à ce jour à notre connaissance, sous réserve de vérification auprès de la société de gestion",
	estimation_amount_demembrement: "Valeur estimée en démembrement",
	demembrement_end_date: "Date de fin de démembrement",
};

export default translations;
